import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PagingInfo} from "src/app/shared";
import { FvmsApiBaseService } from "./fvms.api.base.service";

@Injectable({providedIn: 'root'})
export class FvmsApiDtgInstallService extends FvmsApiBaseService {
    constructor(
        public http:HttpClient
    ) {
        super(http);
    }

    getInstallStatusList(searchKey:string):Observable<any>{
        let url = this.getApiBaseUrl() + "/install/status";
        url += "/list";
        url += `?searchKey=${searchKey}`;

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        return this.http.get<any>(url,{ headers : header });
    }
}